const firebaseConfig = {
  apiKey: "AIzaSyBFoz1yve75TTm0gi5hP0zyMzKMyp-TkSM",
  authDomain: "clothify-db-60953.firebaseapp.com",
  projectId: "clothify-db-60953",
  storageBucket: "clothify-db-60953.appspot.com",
  messagingSenderId: "734505893543",
  appId: "1:734505893543:web:b5de10868537d059c5a582"
};

export default firebaseConfig;
